import { jsx as _jsx } from "react/jsx-runtime";
import { InstructionElement } from './InstructionElement';
export var PlatformNotSelectedInstructions = function () { return (_jsx(InstructionElement, { children: "Please select the platform to see instructions." })); };
